import { render, staticRenderFns } from "./pvExamShowStudentData.vue?vue&type=template&id=8f9c0d24&scoped=true&"
import script from "./pvExamShowStudentData.vue?vue&type=script&lang=js&"
export * from "./pvExamShowStudentData.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f9c0d24",
  null
  
)

export default component.exports